<section>
  <app-text class="text-align-center has-text-medium-grey is-family-bold is-size-4">{{'iaq-app.__IAQ_NO_ACCESS' | AsyncLang | async}}</app-text>

  <img src="assets/images/full-large-general-get-access.png">

  <app-text class="text-align-center has-text-medium-grey is-family-medium">{{'iaq-app.__IAQ_NO_ACCESS_BUILDING' | AsyncLang | async}}</app-text>

</section>
